<template>
  <v-container fluid grid-list-lg>
    <Create :createDialog="createDialog" @close="close" @createdScreen="createdScreen"></Create>
    <Edit :editDialog="editDialog" @close="closeEdit" @updatedScreen="updatedScreen" :editScreen="selectedScreen"></Edit>
    <v-card :loading="loading" outlined>
      <ListTitle
        :showBackButton="true"
        :access="checkRightStatus(2)"
        title="Screens"
        @add="add"
      />
      <v-card-title>
        <v-flex xs12 sm4>
          <v-text-field
            v-model="search"
            outlined
            prepend-inner-icon="search"
            rounded
            dense 
            label="Search"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table :headers="headers" :items="screens" :search="search"
        :loading="loading" :sort-by="sortBy" :page.sync="page" hide-default-footer>
        <template v-slot:item="{ item }">
          <tr class="pointer">
            <td class="text-left">{{ item.createdAt | moment("LL") }}</td>
            <td class="text-left">{{ item.name }}</td>
            <td class="text-left">{{ `portal.taleem.app/tv/${item.code}` }}</td>
            <td class="text-xs-right">
              <v-switch v-model="item.isActive" readonly="readonly"></v-switch>
            </td>
            <td class="justify-end align-center text-right">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">
                  <v-list-item
                    v-if="checkRightStatus(18)"
                    @click="editScreen(item)"
                  >
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="checkRightStatus(10)"
                    @click="removeScreen(item)"
                  >
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no results.</v-alert>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import screenService from '@/modules/MasjidImage/Screen/service.js';
import Create from '@/modules/MasjidImage/Screen/components/Create.vue';
import Edit from '@/modules/MasjidImage/Screen/components/Edit.vue';
import { mapGetters } from "vuex";

export default {
  name: "screen-list",
  data() {
    return {
      page: 1,
      sortBy: "name",
      pageCount: 0,
      itemsPerPage: 10,
      createDialog: false,
      selectedScreen: null,
      editDialog: false,
      headers: [
        {
          text: this.$t('labels.date'),
          value: 'createdAt',
          sortable: true,
        },
        {
          text: this.$t('labels.name'),
          value: 'name',
          sortable: true,
        },
        {
          text: this.$t('labels.url'),
          value: 'code',
          sortable: true,
        },
        {
          text: this.$t('labels.active'),
          value: 'isActive',
          sortable: true,
        },
        {
          text: '',
          value: 'action',
          sortable: false,
        },
      ],
      search: null,
      screens: [],
      loading: true,
    }
  },
  async created() {
    console.log('test im running')
    await this.getList()
  },
  components: {
    Create,
    Edit
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    removeScreen(screen) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          this.$Progress.start()
          return screenService.delete(screen.id).then((response) => {
            if (response.data) {
              this.$swal('Deleted!', 'Screen has been deleted.', 'success')
              this.$Progress.finish()
              this.getList()
            }
          }).catch((err) => {
            this.$swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
            }).fire({
              type: 'error',
              title: err.data.message,
            })
            this.$Progress.fail()
          })
        }
      })
    },
    add() {
      this.createDialog = !this.createDialog
    },
    close() {
      this.createDialog = !this.createDialog
    },
    closeEdit() {
      this.editDialog = false
    },
    createdScreen() {
      this.close()
      this.getList()
    },
    updatedScreen() {
      this.closeEdit()
      this.getList()
    },
    editScreen(data) {
      this.selectedScreen = data
      this.editDialog = !this.editDialog
    },
    updated() {
      this.editDialog = !this.editDialog
      this.getList()
    },
    getList() {
      this.loading = true
      screenService.getall().then((response) => {
        console.log('response', response)
        this.screens = response.data
        this.loading = false
      })
    },
  },
}
</script>
